import React from 'react'
import { localized } from '@/decorators/localized'
import { ValidationBoundary, ValidationState } from '@/components/validation'
import Icon from '@/components/Icon'
import { ButtonSection } from '@/components/Layout'
import { Button } from 'reactstrap'
import OutputReportGroupDefinitionFormContent from './formContent'

@localized()
class OutputReportGroupDefinitionForm extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      ...props.outputReportGroupDefinition
    }
  }
  onChange = (delta) => this.setState(delta)
  onSave = () => {
    this.props.update(this.state)
  }
  render () {
    const { localize } = this.props
    return (
      <ValidationBoundary>
        <OutputReportGroupDefinitionFormContent
          {...this.state}
          onChange={this.onChange}>
          <ValidationState render={({ isValid }) =>
            <ButtonSection>
              <Button className='m-l-a' color='success' disabled={!isValid} onClick={this.onSave}><Icon name='save' /> <span>{localize('Common.Save')}</span></Button>
            </ButtonSection>
          } />
        </OutputReportGroupDefinitionFormContent>
      </ValidationBoundary>
    )
  }
}

export default OutputReportGroupDefinitionForm



// WEBPACK FOOTER //
// ./src/internal-app/pages/outputReportGroupDefinitions/form.js